import React from 'react'
import { useEffect } from "react";
import { useState, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { decryptUserData } from '../../utils/encryptedData'
import { useDispatch } from 'react-redux';
import { ModalAction } from '../../Store/Modal-Slice';
import ImageContainer from '../MainImageComponent/ImageContainer';
import { ComingUpPhotoList } from '../../utils/API/QueuedApi';
import { LightBoxAction } from '../../Store/LightboxSlice';
import amplitude from 'amplitude-js'
import Members from './Members';
import { PayWallAction } from '../../Store/PayWallSlice';

let increment = 0;

const UPComingPhotos = () => {




    let footer = useRef();
    let [firstloadPhoto, setfirstloadPhoto] = useState([])
    let [loadPhoto, setloadPhoto] = useState([])
    let [spinner, setspinner] = useState(false)
    let [CheckEmptyArry, setCheckEmptyArry] = useState(true)
    let [FilterValue, setFilterValue] = useState('')
    let [RecordNotFound, setRecordNotFound] = useState(false)
    let [IsMobile, setIsMobile] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    // let [isPaid, setisPaid] = useState(false)


    let isLogginState = useSelector(state => state.Login.isLoggedIn)
    let UserPaymentStatus = useSelector(state => state.PayWall.UserPaymentStatus)

    let dispatch = useDispatch()

    // <---------------- decrypted data ------------->
    const encryptedUserData = localStorage.getItem('Data');
    const decryptedUserData = decryptUserData(encryptedUserData);
    let usertoken = decryptedUserData.token
    let isloggedin = decryptedUserData.isLoggedIn
    let LoginUserid = decryptedUserData.userid
    let display_name = decryptedUserData.useDisplay_name
    let displaySocailUserPhoto = decryptedUserData.Display_UserSocailPhoto

    // <-------------------------------------------->

    let PayWalltitleObject = () => {
        dispatch(PayWallAction.setPayWallModalTitleObj({ Title: "Upgrade to have full control over when your photos get hunted.", Subtitle: 'Become a Participating Member to schedule your hunted photos, manage them and post them exactly how and when you want.' }))
        dispatch(ModalAction.setisPayWallOpen(true))
    }


    let navigate = useNavigate()

    let NavigateHandler = () => {
        navigate('/queue')
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }






    // ..............................
    let apiCall = (e) => {
        if (e[0].isIntersecting) {
            increment = increment + 10;


            LoadPhotos(increment);
        }


    }

    let LoadMorePhotos = useSelector((state) => state.LightBox.LoadMorePhotos);



    useEffect(() => {
        if (LoadMorePhotos.fetchMorePhotos) {

            increment = increment + 10;
            LoadPhotos(increment);
            dispatch(LightBoxAction.setLoadMorePhotos({ fetchMorePhotos: false, fetchAction: false }))
        }
    }, [LoadMorePhotos.fetchAction])

    let LoadPhotos = async function (incrementValue) {
        setspinner(true)
        try {
            const response = await ComingUpPhotoList(incrementValue)

            const newPhotos = response.data.data.results;
            setloadPhoto(prevPhotos => [...prevPhotos, ...newPhotos])
            amplitude.getInstance().logEvent('View (Scroll) Photo Feed', { UserID: LoginUserid });

            if (newPhotos.length === 0 || newPhotos.length < 10) {
                setCheckEmptyArry(false)
            }

            setspinner(false)

        } catch (error) {

        }
    }


    ///////////

    useEffect(() => {

        const Observer = new IntersectionObserver(apiCall, {
            root: null,
            threshold: 0

        })
        const footerRef = footer.current;
        if (footerRef) {

            Observer.observe(footerRef)
        }
        return () => {
            if (footerRef) Observer.unobserve(footerRef);
        };
    }, [FilterValue, firstloadPhoto, isLogginState])
    ////////////


    useEffect(() => {
        setfirstloadPhoto([])
        setloadPhoto([])
        setRecordNotFound(false)
        if (window.innerWidth <= 500) {
            setIsMobile(true)
        }

        let LoadPhotos = async function () {
            setspinner(true)
            try {
                const response = await ComingUpPhotoList(0)

                const newPhotos = response.data.data.results;

                // setisPaid(response.data.data.isPaid)
                setfirstloadPhoto(newPhotos)
                setspinner(false)
                setCheckEmptyArry(true)
                increment = 0
                if (newPhotos.length == 0) {
                    setRecordNotFound(true)
                }
                if (newPhotos.length < 10) {
                    setCheckEmptyArry(false)
                }
            } catch (error) {


            }

        }
        LoadPhotos();

    }, [isLogginState, FilterValue])

    let AllloadPhoto;

    if (increment === 0) {
        AllloadPhoto = [...firstloadPhoto]
    } else {

        AllloadPhoto = [...firstloadPhoto, ...loadPhoto]

    }

    useEffect(() => {
        if (!isloggedin && AllloadPhoto.length > 10) {
            dispatch(ModalAction.setJoinNowModalState(true))
        }

        if (AllloadPhoto) {
            dispatch(LightBoxAction.setLightBoxState({ PhotoArr: AllloadPhoto, LoginUserPhotos: false }))
        }
    }, [AllloadPhoto])

    return (


        <>

            <section className={`photo-feed-section logout-home`}
                style={{ paddingTop: "40px" }}
            // style={!MarginTopNone ? { marginTop: "40px" } : { marginTop: "0px", paddingTop: "0px" }}
            >
                <div className="container">
                    <div className="row justify-content-center">


                        <div className="col-12 col-lg-4 order-1 order-lg-2 ">
                            <div className="photos-feed_sidebar ">
                                <div className="sidebar_about_page" >
                                    <h5 className="about_title">About this page</h5>
                                    <div className="desc">
                                        <p>This page displays photos scheduled to hunt next week. Click “Notify Me” to get a heads-up when a photo posts, so you can be first to upvote.</p>
                                        <p>Want your photo featured here? Use the <strong>queue feature</strong> and select “<strong>Coming Up.</strong>”</p>

                                    </div>
                                    <a className="btn" onClick={() => setIsModalOpen(true)}>Learn More</a>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-lg-8 order-2 order-lg-1" style={{ padding: "0px" }}>
                            <div className="feed_content_wrap feed_content">
                                <div className="feed_content_heading d-none d-xl-block">
                                    <h3 className="title">Coming Next Week</h3>
                                    <p className="desc">Check out next week’s photos early and get notified the moment they drop—so you can be first to upvote.</p>
                                </div>
                                <div className="feed_items text-center text-md-start">



                                    {AllloadPhoto?.map((data) => (<ImageContainer

                                        img={!IsMobile ? data.photo_url : `https://res.cloudinary.com/duk09hrua/image/upload/c_fit,w_700,f_auto,q_auto/Resized_Photos/${data.compressedImageId}`}
                                        postId={data.id}
                                        key={data.id}
                                        TotalVotes={data.total_votes}
                                        voted={data.is_vote}
                                        Name={data.name}
                                        postedDate={data.photo_posted_date}
                                        Userlocation={data.state}
                                        UserPhoto={data.user_photo_url}
                                        Userid={data.user_id}
                                        usertoken={usertoken}
                                        isLoggedIn={isloggedin}
                                        loginUserid={LoginUserid}
                                        display_name={display_name}
                                        displaySocailUserPhoto={displaySocailUserPhoto}
                                        First1Comments={data.comments}
                                        TotalComments={data.total_comments}
                                        description={data.description}
                                        feedback={data.feedback_type}
                                        metadata={data.metadata}
                                        is_follow={data.is_follow}
                                        UserPaymentStatus={UserPaymentStatus}
                                        is_notify={data.is_notify}
                                        comingUp={true}


                                    />))}
                                    {RecordNotFound && <h4>Record not found</h4>}



                                    {CheckEmptyArry && spinner && <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div className="spinner-border text-secondary" role="status" >
                                            <span className="sr-only"></span>
                                        </div>
                                    </div>}



                                    {CheckEmptyArry && firstloadPhoto.length > 0 && <div ref={footer}></div>}

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section >

            <div className="tab-pane fade show active" id="comingUp" role="tabpanel" style={{ padding: "0px" }}>
                <div className="tab_content coming_up" style={{ paddingTop: "40px" }}>
                    <div className="container">
                        <div className="row">
                            {/* About this page Section */}
                            <div className="col-12 col-lg-4 order-1 order-lg-2 " style={{ marginBottom: "30px" }} >

                            </div>



                        </div>
                    </div>
                </div>
            </div>




            {isModalOpen && <>
                <div className="backdrop" />
                <div className="modal fade bph-modal show" id="QueuedPhotoModal" tabIndex={-1} aria-labelledby="sharePhotoModal" aria-hidden="true" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-centered modalAnimation">
                        <div className="modal-content">
                            <div className="modal-body">
                                {/* First */}
                                <div className="onboarding_modal photoUpload_modal photoQueued">
                                    <div className="modal_inner">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleCloseModal} />
                                        {/* logo */}
                                        <div className="modal_logo d-none d-md-inline-flex ">
                                            <img src="./assets/img/logo/modal-logo.png" alt />
                                        </div>
                                        {/* content */}
                                        <div className="modal_content photoQueue_content">
                                            <div className="modal_title">
                                                <h3 className="title"><img src="./assets/img/icons/info.svg" alt />Coming Next</h3>
                                                {UserPaymentStatus ? (

                                                    <p className="desc">
                                                        You’re a Pro Member—let’s put that to work. You can add your photo to the Coming Next feed for early exposure before the Hunt begins. Members can preview it, tap “Notify Me,” and be ready to upvote when it drops.
                                                    </p>


                                                ) : (
                                                    <p className="desc"><strong>Unlock Early Exposure</strong>: Post your photo in the Coming Next feed the week before it’s hunted. <br /> <br /> Upgrade to Pro so members can preview it, get notified, and be first to upvote—giving your photo a head start on visibility.

                                                    </p>
                                                )}

                                                <button
                                                    className="btn"
                                                    type="submit"
                                                    onClick={() => {
                                                        UserPaymentStatus ? NavigateHandler() : PayWalltitleObject()
                                                    }}
                                                >
                                                    {(UserPaymentStatus ? "Take Me There" : "Show Me Pro!")}
                                                </button>
                                                <span
                                                    className="btn_note"
                                                    onClick={handleCloseModal}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    Maybe later
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
        </>

    )
}

export default UPComingPhotos
